const columns = [
  {
    header: 'Reference',
    field: 'reference',
    sortable: true,
  },
  {
    header: 'Company',
    field: 'company',
    sortable: true,
  },
  {
    header: 'Brand',
    field: 'brand',
    sortable: true,
  },
  {
    header: 'Shipment #',
    field: 'shipmentNumber',
    sortable: true,
  },
  {
    header: 'HAWB #',
    field: 'hawbNumber',
    sortable: true,
  },
  {
    header: 'Nature of loss',
    field: 'natureOfLoss',
    sortable: true,
  },
  {
    header: 'Amount',
    field: 'amount',
    sortable: true,
  },
  {
    header: 'Claim date',
    field: 'claimDate',
    sortable: true,
  },
  {
    header: 'Notified',
    field: 'notifyingDate',
    sortable: true,
  },
  {
    header: 'Status',
    field: 'status',
    sortable: true,
  },
  {
    header: 'Credit note',
    field: 'creditNote',
    sortable: false,
  },
];

export default columns;
